import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  Box,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../../../utils/api';

const ViewReceipt = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const superAdminId = user?.id;
  const navigate = useNavigate();

  const [receipts, setReceipts] = useState([]);

  useEffect(() => {
    const fetchReceipts = async () => {
      try {
        const res = await api.get(`/api/receipts/get-all/${superAdminId}`);
        setReceipts(res.data);
      } catch (err) {
        console.error('Error fetching receipts:', err);
      }
    };

    fetchReceipts();
  }, [superAdminId]);

  const handleDelete = async (id) => {
    if (window.confirm('Delete this receipt?')) {
      try {
        await api.delete(`/api/receipts/delete/${id}`);
        setReceipts(receipts.filter((r) => r._id !== id));
      } catch (err) {
        console.error('Failed to delete:', err);
      }
    }
  };

  return (
    <SuperAdminLayout>
      <Container maxWidth="screen" sx={{ mt: 4 }}>
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={2}
        >
          <Typography variant="h5">All Receipts</Typography>
          <Button
            variant="contained"
            onClick={() => navigate('/super-admin/receipt/create')}
          >
            + Create Receipt
          </Button>
        </Box>
        <Paper elevation={3}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Party Name</TableCell>
                <TableCell>Type</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {receipts.map((r) => (
                <TableRow key={r._id}>
                  <TableCell>
                    <IconButton
                      color="error"
                      onClick={() => handleDelete(r._id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    {new Date(r.date).toISOString().slice(0, 10)}
                  </TableCell>
                  <TableCell>{r.partyName}</TableCell>
                  <TableCell>{r.paymentType}</TableCell>
                  <TableCell>Rs. {Number(r.amount).toFixed(2)}</TableCell>
                  <TableCell>{r.remarks}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </Container>
    </SuperAdminLayout>
  );
};

export default ViewReceipt;
